export default "__VITE_ASSET__BI94eA8D__"